import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import { SeoSchemaResponse } from "./seoServiceInterface";

class SeoServiceApi {
  private baseUrl: string;

  private basePath: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "v1/seo";
  }

  // ******************************************************
  // ****************** Method: GET ***********************
  // ******************************************************

  async getHotelSEOPage(
    params: string,
  ): Promise<SeoSchemaResponse | undefined> {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePath}/getseoSchemaHotels?url=${params}`,
      "GET",
    )) as any;

    if (!response.status) {
      return undefined;
    }

    return new SeoSchemaResponse(response);
  }

  async getFlightSEOPage(
    params: string,
  ): Promise<SeoSchemaResponse | undefined> {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePath}/getseoSchemaFlights?url=${params}`,
      "GET",
    )) as any;

    if (!response.status) {
      return undefined;
    }

    return new SeoSchemaResponse(response);
  }

  async getAirlineSEOPage(
    params: string,
  ): Promise<SeoSchemaResponse | undefined> {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePath}/getseoSchemaAirlines?url=${params}`,
      "GET",
    )) as any;

    if (!response.status) {
      return undefined;
    }

    return new SeoSchemaResponse(response);
  }

  async getTourSEOPage(params: string): Promise<SeoSchemaResponse | undefined> {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePath}/getseoSchemaTourPackages?url=${params}`,
      "GET",
    )) as any;

    if (!response.status) {
      return undefined;
    }

    return new SeoSchemaResponse(response);
  }

  async getKlubSEOPage(params: string): Promise<SeoSchemaResponse | undefined> {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePath}/getseoSchemaKlub?url=${params}`,
      "GET",
    )) as any;

    if (!response.status) {
      return undefined;
    }

    return new SeoSchemaResponse(response);
  }

  async getCarRentalSEOPage(
    params: string,
  ): Promise<SeoSchemaResponse | undefined> {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePath}/getseoSchemaCarRentals?url=${params}`,
      "GET",
    )) as any;

    if (!response.status) {
      return undefined;
    }

    return new SeoSchemaResponse(response);
  }
}

export default SeoServiceApi;
